const registration = {
    links: {
        payment: 'Към плащане за вече регистрирани потребители',
        participants: 'Виж регистрираните участници',
        results2025: 'Виж резултатите за 2025 г.',
        results2026: 'Виж резултатите за 2026 г.',
    },
    notices: {
        testMode: 'TEST MODE: Плащането е с тестова цена.',
        activeDiscount: 'Активен код за отстъпка от таксата за регистрация: {{discountPercent}}%',
        inactiveDiscount: 'Кодът за отстъпка вече не е активен.',
        invalidDiscount: 'Невалиден или неактивен код за отстъпка.',
        discountUsesLeft: 'Остават {{count}} използвания за този код за отстъпка.',
        discountNoUsesLeft: 'Този код за отстъпка няма оставащи използвания.',
        spacesLeft: 'Остават {{count}} свободни места за регистрация.',
        checkingOpeningDate: 'Проверка кога се отваря регистрацията...',
        registrationOpensOn: 'Регистрацията ще отвори на {{date}}.',
        registrationFull: 'Достигнат е максималният брой участници. Регистрацията е затворена.',
        formHasErrors: 'Моля, попълнете всички задължителни полета. При проблем, моля свържетe се с info@osogovo.run',
    },
    tiers: {
        title: 'Нива на таксата за регистрация',
        range: 'Участници {{from}}–{{to}}',
        fee: 'Такса за {{distance}} км: €{{amount}}',
        tShirt: 'Тениска: €{{amount}}',
        tShirtUnavailable: 'Без тениска',
        current: '{{count}} регистрирани',
    },
    countdown: {
        title: 'Стартът е след',
        started: 'Състезанието започна',
        days: 'дни',
        hours: 'часа',
        minutes: 'мин',
        seconds: 'сек',
    },
    fields: {
        distance: 'Дистанция',
        email: 'Email',
        emailPlaceholder: 'Въведете валиден email',
        name: 'Име и фамилия (на латиница)',
        namePlaceholder: 'Име и фамилия',
        phoneNumber: 'Телефонен номер',
        phonePlaceholder: '+359 / 0898 / +1-234-567-8900',
        gender: 'Пол',
        genderMale: 'Мъж',
        genderFemale: 'Жена',
        birth: 'Дата на раждане',
        country: 'Държава',
        team: 'Отбор',
        itraId: 'ITRA ID',
        optional: '(по желание)',
        discountCode: 'Код за отстъпка',
        discountCodePlaceholder: 'Въведете код за отстъпка',
        distance14: 'х.Осогово - 14км',
        distance26: 'вр.Руен - 27км',
    },
    terms: 'Подавайки заявка за участие декларирам, че съм съгласен с правилата и условията на всяко състезание и ще ги спазвам. Ще участвам по собствено желание и на собствена отговорност, като освобождавам от такава организаторите.',
    tShirt: {
        label: 'Добави официална тениска за бягане Osogovo Run (по желание)',
        unavailableLabel: 'Поръчването на официална тениска вече не е възможно',
        imageAlt: 'Официална тениска',
        add: 'Добави тениска',
        remove: 'Премахни тениска',
        addedCaption: 'Тениската е добавена (+{{price}} eur) - натиснете за премахване',
        addCaption: 'Добави тениска (+{{price}} eur)',
        sizeLabel: 'Избери размер',
        unavailable: 'Поръчването на тениска вече не е възможно. Можете да продължите към плащането без тениска.',
        proceedWithout: 'Продължи към плащането',
    },
    payment: {
        entryFee: 'Плащане на стартова такса: {{amount}} eur.',
        discount: 'Отстъпка от стартовата такса: ({{discountPercent}}%): -{{amount}} eur.',
        tShirt: 'Тениска: {{amount}} eur.',
        total: 'Общо: {{amount}} eur.',
        currentTotal: 'Текуща обща сума: {{amount}} eur.',
        freeRegistration: 'Регистрацията е безплатна с приложения код за отстъпка. Натиснете бутона, за да завършите регистрацията си.',
        redirectInfo: 'След валидиране на данните ще бъдете пренасочени към защитената платежна страница.',
        confirmationInfo: 'Регистрацията се потвърждава след успешно плащане и сървърна проверка на транзакцията.',
        redirecting: 'Пренасочване...',
        finishFree: 'Завърши регистрацията',
        payAmount: 'Плати {{amount}} eur.',
    },
    paymentPages: {
        common: {
            home: 'Начална страница',
            toRegistration: 'Към регистрация',
            toRegistrationDefinite: 'Към регистрацията',
            toParticipants: 'Виж участниците',
            redirecting: 'Пренасочване...',
        },
        request: {
            title: 'Повторно плащане',
            instructions: 'Въведете имейла, с който сте направили регистрацията.',
            emailLabel: 'Имейл',
            emailPlaceholder: 'Въведете валиден email',
            submit: 'Изпрати линк за плащане',
            submitting: 'Изпращане...',
            missingApi: 'Липсва настройка на API. Моля, опитайте отново по-късно.',
            defaultMessage: 'Ако имейлът е вече регистриран и плащането не е било успешно, ще получите имейл с линк за повторно плащане. Ако не сте регистрирани, моля, използвайте страницата за регистрация.',
        },
        cancel: {
            title: 'Плащането не беше завършено',
            defaultMessage: 'Регистрацията е запазена като изчакваща, но не е потвърдена. Можете да стартирате плащането отново, когато сте готови.',
            payLaterEmailSent: 'Регистрацията е запазена. Изпратихме имейл с инструкции за плащане по банков път. При нужда: info@osogovo.run',
            pendingWithoutEmail: 'Регистрацията е запазена като изчакваща. Ако не получите инструкции за плащане, пишете ни на info@osogovo.run',
            retryError: 'Възникна грешка при повторно стартиране на плащането. Моля, опитайте отново.',
            retry: 'Опитайте отново',
        },
        success: {
            titles: {
                paid: 'Благодарим Ви за регистрацията{{namePart}}!',
                pending: 'Плащането се обработва',
                cancelled: 'Плащането е прекратено',
                missing: 'Липсва информация за плащането',
                error: 'Не успяхме да потвърдим плащането',
                loading: 'Проверяваме плащането',
            },
            namePart: ', {{name}}',
            messages: {
                paid: 'Плащането е потвърдено успешно и регистрацията Ви е активна. Очакваме Ви на старта на състезанието.',
                pending: 'Сървърът все още изчаква окончателно потвърждение. Обновете страницата след няколко секунди.',
                cancelled: 'Не получихме успешно потвърдено плащане за тази регистрация. Можете да опитате отново.',
                missing: 'Отворете тази страница само след връщане от системата за плащане или започнете нова регистрация.',
                error: 'Възникна проблем при проверката на плащането. Ако сумата е била удържана, свържете се с info@osogovo.run.',
                loading: 'Моля, изчакайте, докато проверим състоянието на плащането.',
            },
            checkAgain: 'Провери отново',
        },
        retry: {
            missingEmail: 'Липсва имейл адрес. Моля, опитайте отново.',
            failedInit: 'Възникна грешка при инициализиране на плащането. Моля, свържете се с info@osogovo.run.',
            loadingTitle: 'Пренасочваме Ви към плащането...',
            loadingSubMessage: 'Регистрация с имейл адрес: ',
            loadingMessage: 'Моля, изчакайте.',
            errorTitle: 'Възникна проблем',
            toRegistered: 'Към регистрираните',
        },
    },
    errors: {
        required: 'Задължително поле',
        invalidEmail: 'Невалиден формат на имейл адрес',
        invalidPhoneCharacters: 'Телефонният номер може да съдържа само цифри, +, - и интервали',
        phoneTooShort: 'Телефонният номер трябва да е поне 8 символа',
        nameTooShort: 'Името трябва да е поне 4 символа',
        fullNameRequired: 'Необходими са две имена',
        nameLatinOnly: 'Моля, въведете имената си на латиница',
        termsRequired: 'Трябва да се съгласите с условията за участие',
        tShirtSizeRequired: 'Изберете размер на тениската',
        missingPaymentConfiguration: 'Липсва конфигурация за плащането. Моля, свържете се с info@osogovo.run.',
        emailAlreadyPaid: 'Имейлът вече е регистриран с потвърдено плащане. Моля, свържете се с info@osogovo.run за повече информация.',
        paymentPending: 'Имейлът вече е регистриран, но плащането не е завършено. <a href="{{retryUrl}}">Опитайте отново с плащането</a> или <a href="mailto:info@osogovo.run">се свържете с нас</a>.',
        checkoutRedirectFailed: 'Възникна грешка при пренасочването към плащането. Моля, опитайте отново по-късно или се свържете с info@osogovo.run.',
        registrationFull: 'Достигнат е максималният брой участници. Регистрацията е затворена.',
    },
};

export default registration;
